<div class="tile">
  <h5 class="mb-4 font-medium">
    {{ 'instrument-detail.instrument-documents.headline' | transloco }}
  </h5>
  <div class="font-light">
    <div class="d-flex justify-content-between">
      @if (model?.baseInfoLink) {
        <div>
          <a [href]="model?.baseInfoLink" target="_blank" class="link-secondary text-default">{{
            'instrument-detail.instrument-documents.rows.baseInfoLink' | transloco
          }}</a>
        </div>
      }
      @if (model?.salesbrochure) {
        <div>
          <a [href]="model?.salesbrochure" target="_blank" class="link-secondary text-default">{{
            'instrument-detail.instrument-documents.rows.salesbrochure' | transloco
          }}</a>
        </div>
      }
    </div>

    @if (model?.semiAnnualReport || model?.annualReport) {
      <hr class="less-margin" />
      <div class="d-flex justify-content-between">
        @if (model?.semiAnnualReport) {
          <div>
            <a [href]="model?.semiAnnualReport" target="_blank" class="link-secondary text-default">{{
              'instrument-detail.instrument-documents.rows.semiAnnualReport' | transloco
            }}</a>
          </div>
        }
        @if (model?.annualReport) {
          <div>
            <a [href]="model?.annualReport" target="_blank" class="link-secondary text-default">{{
              'instrument-detail.instrument-documents.rows.annualReport' | transloco
            }}</a>
          </div>
        }
      </div>
    }
  </div>
</div>
